/**
 * Session persistence. The handoff is explicit: store the raw accessToken
 * WITHOUT the word "Bearer" (Bearer is added only on the Authorization header),
 * and persist expiresAtUtc plus the returned roles with the session.
 */

const TOKEN_KEY = 'vh_admin_token';
const EXPIRES_KEY = 'vh_admin_expires';
const USER_KEY = 'vh_admin_user';

export const setSession = ({ accessToken, expiresAtUtc, firstName, lastName, email, roles }) => {
  if (accessToken) localStorage.setItem(TOKEN_KEY, accessToken);
  if (expiresAtUtc) localStorage.setItem(EXPIRES_KEY, expiresAtUtc);
  localStorage.setItem(
    USER_KEY,
    JSON.stringify({ firstName, lastName, email, roles: roles || [] })
  );
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getExpiresAt = () => localStorage.getItem(EXPIRES_KEY);

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY)) || null;
  } catch {
    return null;
  }
};

export const getRoles = () => getUser()?.roles || [];

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRES_KEY);
  localStorage.removeItem(USER_KEY);
};

/** True when a token exists and (if an expiry is known) has not passed. */
export const isSessionValid = () => {
  const token = getToken();
  if (!token) return false;
  const expires = getExpiresAt();
  if (expires && new Date(expires).getTime() <= Date.now()) return false;
  return true;
};
